import { useContext, useEffect, useState } from "react";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-modal';
import Select from 'react-select';
import 'react-toggle/style.css';
import Swal from "sweetalert2";
import { refeshPend } from "../../../App";
import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";
import '../../Admin Master/Transport Master/modemaster.css';


function ScanbyAirway() {

    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const [getScan, setGetScan] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedScanRows, setSelectedScanRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedDocketNos, setSelectedDocketNos] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const { hubFun } = useContext(refeshPend);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [fromDate, setFromDate] = useState(firstDayOfMonth);
    const [toDate, setToDate] = useState(today);
    const statusOptions = [
        { value: "Arrived", label: "Arrived" },
        // (maybe you meant "Return"?)
    ];
    const [formData, setFormData] = useState({
        DocketNo: [],
        Inscan_Status: "Arrived",
        Inscan_Remark: "",
        docketNo: "",
        masterAwbNo:"",
    })

    const fetchData = async () => {
        setLoading(true);
        try {
            const login = JSON.parse(localStorage.getItem("Login"));
            const formatDate = (date) => {
                const d = new Date(date);
                return d.toISOString().split("T")[0]; // ✅ SAFE
            };

            const response = await getApi(
                `/Inscan/pendingInscan?&DocketNo=${searchQuery}&branchCode=${login?.Branch_Code}&pageNumber=${currentPage}&pageSize=${rowsPerPage}&FromDate=${fromDate}&ToDate=${toDate}`
            );
            const currentPageData = response?.data || [];
            setGetScan(currentPageData);
            // ✅ USE BACKEND COUNT
            setTotalRecords(response?.totalCount || 0);

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };


    const handleDocketNoSelect = () => {
        setFormData((prevData) => ({
            ...prevData,
            docketNo: selectedDocketNos,
        }));
        setModalIsOpen(false);
    };

    useEffect(() => {
        fetchData();
    }, [currentPage, rowsPerPage, toDate, fromDate, searchQuery]);



    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const handleSelectAll = () => {
        const newState = !selectAll;
        setSelectAll(newState);

        if (newState) {
            // Select All
            setSelectedRows(getScan.map((_, index) => index));                    // row index array
            setSelectedDocketNos(getScan.map(m => m.DocketNo));                   // all docket numbers
            setSelectedScanRows([...getScan]);                                // entire row data
        } else {
            // Unselect All
            setSelectedRows([]);
            setSelectedDocketNos([]);
            setSelectedScanRows([]);
        }
    };

    const handleRowSelect = (index, docketNo, n) => {
        const already = selectedRows.includes(index);
        const updatedRows = already ? selectedRows.filter(i => i !== index) : [...selectedRows, index];
        if (already) {
            setSelectedDocketNos(selectedDocketNos.filter(docket => docket !== docketNo));
            setSelectedScanRows(selectedScanRows.filter(row => row.DocketNo !== docketNo));
        } else {
            setSelectedDocketNos([...selectedDocketNos, docketNo]);
            setSelectedScanRows([
                ...selectedScanRows,
                getScan.find(data => data.DocketNo === docketNo)
            ]);
        }
        setSelectedRows(updatedRows);
        setSelectAll(updatedRows.length === n);
    };

    const handleFind = async () => {
    const doc = String(formData.docketNo)
        .trim()
        .replace(/\r|\n/g, "");

    if (!doc) return;

    try {
        setLoading(true);

        const response = await getApi(
            `/Inscan/pendingInscanSearch?DocketNo=${doc}&FromDate=&ToDate=&pageNumber=1&pageSize=1`
        );

        const found = response.data?.[0];

        if (!found) {
            Swal.fire({
                icon: "error",
                title: "Not Found!",
                text: `Docket No ${doc} not exists`
            });

            setFormData(prev => ({
                ...prev,
                docketNo: ""
            }));
            return;
        }

        if (selectedDocketNos.includes(doc)) {
            Swal.fire({
                icon: "warning",
                title: "Already Selected",
                text: `Docket No ${doc} already added`
            });

            setFormData(prev => ({
                ...prev,
                docketNo: ""
            }));
            return;
        }

        setSelectedDocketNos(prev => [...prev, doc]);
        setSelectedScanRows(prev => [...prev, found]);


        setFormData(prev => ({
            ...prev,
            docketNo: ""
        }));

    } catch (error) {
        console.log(error);

        Swal.fire({
            icon: "error",
            title: "Error",
            text: "Unable to fetch docket."
        });
    } finally {
        setLoading(false);
    }
};





    const totalPages = Math.ceil(totalRecords / rowsPerPage);

    const handlePreviousPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);
    const handleNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (JSON.parse(localStorage.getItem("Login"))?.Branch_Code === "ALB") {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'You Can not scan data,please login the branch',
            });
            return;
        }
        if (selectedDocketNos.length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Please select at least one Docket No before submitting the form.',
            });
            return;
        }
        const requestPayload = {
            DocketNo: selectedDocketNos,
            SessionLocationCode: JSON.parse(localStorage.getItem("Login"))?.Branch_Code,
            Inscan_Status: formData.Inscan_Status,
            Inscan_Remark: formData.Inscan_Remark
        };

        try {
            const response = await postApi('/Inscan/generateInscan', requestPayload);
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Data has been successfully generated!',
                timer: 2000,
                showConfirmButton: false,
            });
            setFormData({
                Inscan_Status: "Arrived",
                Inscan_Remark: "",
                masterAwbNo:"",
                DocketNo:[],
                docketNo: "",
            });
            setSelectedRows([]);
            setSelectedDocketNos([]);
            setSelectedScanRows([]);
            await fetchData();
            hubFun();
        } catch (error) {
            console.error("Error submitting Inscan: ", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong while generating data. Please try again.',
            });
        }
    };



    return (
        <div className="body">

            <div className="container1">
                <form action="" onSubmit={handleSubmit}>
                    <div className="fields2">
                        {/* <div className="input-field3">
                            <label>Master Awb No</label>
                            <input type="text"
                                className="input" placeholder="Enter Master Awb No" value={formData.masterAwbNo}
                                onChange={(e) => setFormData({ ...formData, masterAwbNo: e.target.value })} />
                        </div> */}
                        <div className="input-field3">
                            <label>Status</label>
                            <Select
                                options={statusOptions}
                                value={statusOptions.find(opt => opt.value === formData.Inscan_Status) || null}
                                onChange={(selectedOption) =>
                                    setFormData({
                                        ...formData,
                                        Inscan_Status: selectedOption ? selectedOption.value : ""
                                    })
                                }
                                placeholder="Select Status"
                                required
                                isSearchable
                                classNamePrefix="blue-selectbooking"
                                className="blue-selectbooking"
                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                styles={{
                                    placeholder: (base) => ({
                                        ...base,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }),
                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                }}
                            />
                        </div>



                        <div className="input-field3">
                            <label>Master Awb No</label>
                            <input type="text"
                                className="input" placeholder="Enter Master Awb No" value={formData.Inscan_Remark}
                                onChange={(e) => setFormData({ ...formData, Inscan_Remark: e.target.value })} />
                        </div>

                        

                        <div className="input-field3" style={{minWidth:"220px"}}>
                            <label>Docket No</label>
                            <div style={{ display: "flex", gap: "5px" }}>
                                <input
                                    style={{ flex: 1 }}
                                    type="text"
                                    className="input"
                                    placeholder="Enter Docket No"
                                    autoFocus
                                    value={formData.docketNo}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            docketNo: e.target.value
                                        })
                                    }
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault(); // stop form submit
                                            handleFind();       // auto call after scan
                                        }
                                    }}
                                />
                                <button type="button" className="ok-btn" style={{ width: "40px" }} onClick={handleFind}>Find</button>
                            </div>
                        </div>

                        
                       


                        <div className="bottom-buttons" style={{ marginTop: "23px", marginLeft: "10px" }}>
                            <button className="ok-btn" type="button" onClick={() => { setModalIsOpen(true) }} style={{ width: "70px" }}>Bulk</button>
                            <button className="ok-btn" type="submit" style={{ width: "70px" }}>Submit</button>
                            <button type="button" className="ok-btn" style={{ width: "70px" }}>Cancel</button>
                        </div>
                    </div>
                </form>


                <div className="table-container">
                    <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
                        <thead className="table-sm">
                            <tr>
                                <th className="w-60">Sr.No</th>
                                <th >Branch.Code</th>
                                <th >Branch.Name</th>
                                <th >Docket.No</th>
                                <th >Reff.No</th>
                                <th >Date</th>
                                <th >Manifest.Destination</th>
                                <th >Manifest.No</th>
                                <th >Manifest.Date</th>
                                <th >Customer.Name</th>
                                <th >Consignee.Name</th>
                                <th >Origin</th>
                                <th >Destination</th>
                                <th >QTY</th>
                                <th >Weight</th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                selectedScanRows.map((scan, index) => (

                                    <tr key={index}>
                                        <td className="w-60">{index + 1}</td>
                                        <td>{scan.Branch_Code}</td>
                                        <td>{scan.Branch_Name}</td>
                                        <td>{scan.DocketNo}</td>
                                        <td>{scan?.VendorAwbNo}</td>
                                        <td>{scan.BookDate}</td>
                                        <td>{scan.Manifest_Destination}</td>
                                        <td>{scan.ManifestNo}</td>
                                        <td>{scan.ManifestDt}</td>
                                        <td>{scan.Customer_Name}</td>
                                        <td>{scan.Consignee_Name}</td>
                                        <td>{scan.FromDest}</td>
                                        <td>{scan.ToDest}</td>
                                        <td>{scan.qty}</td>
                                        <td>{scan.actualWt}</td>

                                    </tr>


                                ))}
                        </tbody>
                    </table>
                </div>

                <Modal
                    overlayClassName="custom-overlay"
                    isOpen={modalIsOpen}
                    className="custom-modal"
                    contentLabel="Modal"
                    style={{
                        content: {
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',

                            overflowY: 'auto',     // ✅ enable vertical scroll
                            overflowX: 'auto',   // optional (clean UI)
                            zIndex: "999999999",
                        },
                    }}
                >
                    <div className="custom-modal-content">
                        <div className="header-tittle" style={{ display: "flex", flexDirection: "row" }}>
                            <header style={{ width: "95%", textAlign: "center" }}>Pending Scan Data</header>
                            <button className="ok-btn" style={{ width: "60px", height: "100%", backgroundColor: "red" }}
                                onClick={() => setModalIsOpen(false)}>
                                <i className="bi bi-x-lg"></i>
                            </button>
                        </div>
                        <div className='container2' style={{ borderRadius: "0px", padding: "10px" }}>

                            <div className="addNew" style={{ whiteSpace: "nowrap" }}>


                                <div className="search-input">
                                    <input
                                        className="add-input1"
                                        type="text"
                                        placeholder="search"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                        style={{ marginLeft: "0%" }}
                                    />
                                    <button type="submit" title="search">
                                        <i className="bi bi-search"></i>
                                    </button>
                                </div>


                                <div className="custom-field">

                                    <div className="custom-date input-field">
                                        <label >From Date</label>
                                        <DatePicker
                                            portalId="root-portal"
                                            selected={fromDate}
                                            onChange={(date) => setFromDate(date)}
                                            dateFormat="dd/MM/yyyy"

                                        />
                                    </div>

                                    <div className="custom-date input-field" >
                                        <label >To Date</label>
                                        <DatePicker
                                            portalId="root-portal"
                                            selected={toDate}
                                            onChange={(date) => setToDate(date)}
                                            dateFormat="dd/MM/yyyy"

                                        />
                                    </div>

                                </div>



                                <div className="bottom-buttons">
                                    <button style={{ marginTop: "5px" }} className="ok-btn" onClick={handleDocketNoSelect}>Submit</button>
                                </div>

                            </div>
                            <div className='table-container' style={{ maxHeight: "300px", overflowY: "auto" }}>
                                <table className='table table-bordered table-sm' style={{ whiteSpace: "nowrap" }}>
                                    <thead className='table-sm'>
                                        <tr style={{ position: "sticky", top: 0, zIndex: 2 }}>
                                            <th className="w-60">
                                                <input type="checkbox" checked={selectAll}
                                                    onChange={handleSelectAll} />
                                            </th>

                                            <th className="w-60">Sr.No</th>
                                            <th >Branch.Code</th>
                                            <th >Branch.Name</th>
                                            <th >Docket.No</th>
                                            <th >Date</th>
                                            <th >Manifest.Destination</th>
                                            <th >Manifest.No</th>
                                            <th >Manifest.Date</th>
                                            <th >Customer.Name</th>
                                            <th >Consignee.Name</th>
                                            <th >Origin</th>
                                            <th >Destination</th>
                                            <th >QTY</th>
                                            <th >Weight</th>

                                        </tr>
                                    </thead>
                                    <tbody className='table-body'>

                                        {
                                            getScan.map((scan, index) => (
                                                <tr key={index}>
                                                    <td scope="col" className="w-60">
                                                        <input type="checkbox" checked={selectedRows.includes(index)}
                                                            onChange={() => handleRowSelect(index, scan.DocketNo, getScan.length)} />
                                                    </td>
                                                    <td className="w-60">{index + 1}</td>
                                                    <td>{scan.Branch_Code}</td>
                                                    <td>{scan.Branch_Name}</td>
                                                    <td>{scan.DocketNo}</td>
                                                    <td>{scan.BookDate}</td>
                                                    <td>{scan.Manifest_Destination}</td>
                                                    <td>{scan.ManifestNo}</td>
                                                    <td>{scan.ManifestDt}</td>
                                                    <td>{scan.Customer_Name}</td>
                                                    <td>{scan.Consignee_Name}</td>
                                                    <td>{scan.FromDest}</td>
                                                    <td>{scan.ToDest}</td>
                                                    <td>{scan.qty}</td>
                                                    <td>{scan.actualWt}</td>
                                                </tr>

                                            ))}

                                    </tbody>
                                </table>
                            </div>

                            <div className="row" style={{ whiteSpace: "nowrap" }}>
                                <div className="pagination col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0">
                                    <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                                        {'<'}
                                    </button>
                                    <span style={{ color: "#333", padding: "5px" }}>
                                        Page {currentPage} of {totalPages}
                                    </span>
                                    <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                                        {'>'}
                                    </button>
                                </div>

                                <div className="rows-per-page col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center">
                                    <span htmlFor="rowsPerPage" className="me-2">Rows per page: </span>
                                    <select
                                        id="rowsPerPage"
                                        value={rowsPerPage}
                                        onChange={(e) => {
                                            setRowsPerPage(Number(e.target.value));
                                            setCurrentPage(1);
                                        }}

                                        style={{ height: "40px", width: "50px", border: "1.5px solid #002357" }}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={200}>200</option>
                                        <option value={500}>500</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >


            </div>
        </div>
    );
};


export default ScanbyAirway;